// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { RadioGroup } from '@mui/material';

export const StyledUiRadioGroup = styled(RadioGroup)(
  () => css`
    display: inline !important;

    .MuiFormHelperText-root {
      margin: 0px 5px 0;
      display: inline;
      font-size: 0.625rem;
      text-align: right;
      font-family: inherit !important;
      color: #d32f2f;
      margin-right: 28px;
    }
  `
);
